export default __webpack_public_path__ + "static/media/icon_dashboard_pressed.a63de0ac.svg";